export default "__VITE_ASSET__c5592468__"